var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"name":"dialog"}}),_vm._v(" "),(_vm.asyncFlag)?_c('Quiz',{attrs:{"question":_vm.question,"cnt":_vm.questionSet.length},on:{"switch-question":_vm.saveAndGetSingleQuestion}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16fe96ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/modules/course/quizContainer.vue
// module id = null
// module chunks = 